export default __webpack_public_path__ + "static/media/newIcon.4ff31bf5.svg";